import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CartService } from '../../services/cart.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-cart-drawer',
  imports: [CommonModule, RouterLink],
  templateUrl: './cart-drawer.html',
})
export class CartDrawer {
  cartService = inject(CartService);
  authService = inject(AuthService);

  decrease(itemId: string, quantity: number): void {
    if (quantity <= 1) return;
    this.cartService.updateItem(itemId, quantity - 1).subscribe({ error: (e) => this.cartService.setErrorFrom(e) });
  }

  increase(itemId: string, quantity: number): void {
    this.cartService.updateItem(itemId, quantity + 1).subscribe({ error: (e) => this.cartService.setErrorFrom(e) });
  }

  remove(itemId: string): void {
    this.cartService.removeItem(itemId).subscribe({ error: (e) => this.cartService.setErrorFrom(e) });
  }
}
